import { render, staticRenderFns } from "./RobotList.vue?vue&type=template&id=88e70132&scoped=true"
import script from "./RobotList.vue?vue&type=script&lang=js"
export * from "./RobotList.vue?vue&type=script&lang=js"
import style0 from "./RobotList.vue?vue&type=style&index=0&id=88e70132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e70132",
  null
  
)

export default component.exports